import { AibPaymentFormData } from './AibFormData';

export interface RefundCardResult {
  success: boolean;
  message?: string;
  result?: {
    success: boolean;
    result?: string;
  };
}

export interface AibResultSuccess {
  processingUrl: string,
  payment: any, // Payment entity (PaymentDto and Payment entity have dependencies that do not match)
  formData: AibPaymentFormData,
}

export interface AibGenerateRequest {
  success: boolean,
  message?: string,
  result?: AibResultSuccess;
}